'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import { FlexColumn, FlexRow } from 'src/components/Atoms/FlexBox';
import { Tooltip } from 'src/components/Atoms/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import useApi from 'src/hooks/useApi';
import useFeatures from 'src/hooks/useFeatures';
import { Reports } from 'src/api/Reports';
import { styled } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { useDataProvider } from '@effektify/data-provider';
import { Dayjs } from 'dayjs';
import { KNOWN_FEATURES } from 'src/constants/features';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Button from '@mui/material/Button';
import useTranslations from 'src/hooks/useTranslations';
interface ShareProps {
  reportId: string;
}
const IconContainer = styled(FlexColumn)(({
  theme
}) => ({
  '& .MuiSnackbar-root': {
    backgroundColor: '#21201E',
    // Should be theme.colors.surface['brand-dark'], but that color is not correct. Should investigate later
    borderRadius: theme.sizes.radius.md,
    color: theme.colors.text.inverted,
    boxShadow: theme.boxShadows[4]
  }
}));
const ToastMessage = styled(FlexRow)(({
  theme
}) => ({
  padding: theme.sizes.spacing['08'],
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: theme.sizes.spacing['07']
}));
export const Share: React.FC<ShareProps> = t0 => {
  const $ = _c(10);
  const {
    reportId
  } = t0;
  const {
    t
  } = useTranslations();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const {
    isEnabled
  } = useFeatures();
  const ReportsApi = useApi(Reports);
  const {
    formData
  } = useDataProvider();
  let t1;
  if ($[0] !== ReportsApi || $[1] !== formData || $[2] !== reportId) {
    t1 = async () => {
      let queryParams = "";
      if (formData) {
        const queryArray = Object.entries(formData).map(_temp);
        if (queryArray.length > 0) {
          queryParams = `?${queryArray.join("&")}`;
        }
      }
      const response = await ReportsApi.getSharedReportLink(reportId, formData);
      const {
        data
      } = response;
      const shareableLink = data.uri.replace("#", queryParams + "#");
      window.navigator.clipboard.writeText(shareableLink);
      setSnackbarOpen(true);
    };
    $[0] = ReportsApi;
    $[1] = formData;
    $[2] = reportId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleShare = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSnackbarOpen(false);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSnackbarClose = t2;
  let t3;
  if ($[5] !== handleShare || $[6] !== isEnabled || $[7] !== snackbarOpen || $[8] !== t) {
    t3 = isEnabled(KNOWN_FEATURES.SHARE_REPORT) && <IconContainer sx={{
      alignSelf: "flex-end",
      justifyContent: "center",
      height: "40px"
    }}><Tooltip title={t("reportPage.share")} placement="bottom"><Button variant="outlined" onClick={handleShare} aria-label="share"><ShareOutlinedIcon /></Button></Tooltip><Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}><ToastMessage><FontAwesomeIcon icon={faCircleCheck} size="1x" /><Typography variant="heading-md" sx={{
            paddingRight: "1.5rem"
          }}>{t("reportPage.sharedMessage")}</Typography></ToastMessage></Snackbar></IconContainer>;
    $[5] = handleShare;
    $[6] = isEnabled;
    $[7] = snackbarOpen;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(t0) {
  const [key, value] = t0;
  return `${encodeURIComponent(key)}=${encodeURIComponent((value as unknown as Dayjs).toISOString?.() ?? value.toString())}`;
}